//Copyright (C) Siemens Healthineers AG 2024, All rights reserved. Restricted
//
/**
 * Created by z003f2zh on 20.07.2015.
 */

(function () {

    angular
        .module('container.components')
        .service('clipboardService', clipboardService);

    function clipboardService($rootScope) {

        this.clipboardTexts = [];

        this.removeAll = function () {
            this.clipboardTexts = [];
            this.notify();
        };

        this.add = function (text) {
            this.clipboardTexts.unshift(text);
            this.clipboardTexts.slice(0, 5);
            this.clipboardTexts = _.uniq(this.clipboardTexts);
            this.notify();
        };

        this.remove = function (text) {
            _.remove(this.clipboardTexts, function (savedText) {
                return savedText == text;
            });
            this.notify();
        };

        this.notify = function () {
            $rootScope.$apply(function() {
                $rootScope.$broadcast('clipboard:change', this.clipboardTexts);
            }.bind(this));
        };

        $(document).on('copy.clipboard', function (event) {
            this.add(window.getSelection().toString());
        }.bind(this));
    }


}());
